import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { IAlert } from 'src/app/core/interfaces/alert';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  standalone: false,
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css']
})
export class alertComponent implements OnInit {

    info!:IAlert;
    visible:boolean = false;

    constructor(
        private alertService: AlertService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.alertService.init.subscribe((data) => {
            this.info = data.alert
            this.visible = data.visible
            this.cdr.detectChanges();
        }); 
    }

    cerrar(){
        this.alertService.close();
    }

}